import React from 'react';
import Navbar from "../Component/Navbar";
import Aboutuscomp from '../Component/Aboutuscomp';

const  AboutUs=()=>{
    return( 
        <>

        <Navbar/>
        <Aboutuscomp/>
        
        </>
    )
}
export default AboutUs;